let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2Q4bo"), load("22DNY")]).then(() => parcelRequire('6VDyY'));